import type { ToolModeId } from "./types";

export interface ModeInputDrafts extends Record<ToolModeId, string> {}

export function createModeInputDrafts(): ModeInputDrafts {
  return {
    "json-format": "",
    "json-minify": "",
    "json-escape": "",
    "json-unescape": "",
    "url-safe": "",
    "url-full": "",
    "url-decode": "",
    "text-encode": "",
    "text-decode": "",
    "base64-encode": "",
    "base64-decode": "",
    "base64-image": "",
    "html-format": "",
    "html-preview": "",
    "entity-encode": "",
    "entity-decode": "",
    "timestamp-convert": "",
    "cron-describe": "",
    "curl-to-fetch": "",
    "curl-to-axios": "",
    "curl-to-python": "",
    "curl-to-node": "",
    "curl-to-go": "",
    "curl-to-php": "",
    "text-diff-compare": "",
    "query-parse": "",
    "query-build": "",
    "cookie-parse": "",
    "set-cookie-parse": "",
  };
}

export interface SecondaryModeInputDrafts extends Record<ToolModeId, string> {}

export function createSecondaryModeInputDrafts(): SecondaryModeInputDrafts {
  return {
    "json-format": "",
    "json-minify": "",
    "json-escape": "",
    "json-unescape": "",
    "url-safe": "",
    "url-full": "",
    "url-decode": "",
    "text-encode": "",
    "text-decode": "",
    "base64-encode": "",
    "base64-decode": "",
    "base64-image": "",
    "html-format": "",
    "html-preview": "",
    "entity-encode": "",
    "entity-decode": "",
    "timestamp-convert": "",
    "cron-describe": "",
    "curl-to-fetch": "",
    "curl-to-axios": "",
    "curl-to-python": "",
    "curl-to-node": "",
    "curl-to-go": "",
    "curl-to-php": "",
    "text-diff-compare": "",
    "query-parse": "",
    "query-build": "",
    "cookie-parse": "",
    "set-cookie-parse": ""
  };
}

export function switchModeInputDraft(
  drafts: Record<ToolModeId, string>,
  currentModeId: ToolModeId,
  currentInput: string,
  nextModeId: ToolModeId
): string {
  drafts[currentModeId] = currentInput;
  return drafts[nextModeId];
}
